export const UPDATE_LIST = 'UPDATE_LIST'

/**
 * Update state with new list items.
 * @param {Array} items List of items (most likely IDs)
 * @param {number} page Current list page
 * @param {number} count Total amount of items
 * @param {Object} [data] This object contains referenced entities or other additional data
 */
export const updateList = (items, page, count, data = {}) => ({
    type: UPDATE_LIST,
    items,
    page,
    count,
    data,
})

export const UPDATE_PAGE = 'UPDATE_PAGE'

/**
 * Update list page.
 * @param {number} page Number of the new page
 */
export const updatePage = page => ({
    type: UPDATE_PAGE,
    page,
})

export const QUERY_LIST = 'QUERY_LIST'

/**
 * Query latest list data from API.
 */
export const queryList = () => ({
    type: QUERY_LIST,
})

export const RESET_LIST = 'RESET_LIST'

/**
 * Clear all data in the list state.
 */
export const resetList = () => ({
    type: RESET_LIST,
})

export const UPDATE_PAGE_SIZE = 'UPDATE_PAGE_SIZE'

/**
 * Set a new page size.
 * @param {number} pageSize
 */
export const updatePageSize = pageSize => ({
    type: UPDATE_PAGE_SIZE,
    pageSize,
})

export const UPDATE_SORT = 'UPDATE_SORT'

/**
 * Update sorting and order of the list.
 * @param {string} [sort] Sort field
 * @param {"ASC"|"DESC"} [order] Sorting order
 */
export const updateSort = (sort, order) => ({
    type: UPDATE_SORT,
    sort,
    order,
})

export const LIST_QUERY_ERROR = 'LIST_QUERY_ERROR'

/**
 * Set error state for a list.
 * @param {string} message Error message
 */
export const listQueryError = message => ({
    type: LIST_QUERY_ERROR,
    message,
})
